import { TextInput, TextInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';

export const GrayTextInputWithUpperLabel = (props: TextInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  return (
    <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
      <InputLabel className="input-label" required={props.isRequired}>
        {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
      </InputLabel>
      <TextInput
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        fullWidth={props.fullWidth ?? true}
        InputProps={{ ...props.InputProps, notched: false }}
        sx={{
          width: '100%',
          ...props.sx,
        }}/>
    </Box>
  );

};
